import { Button, CircularProgress, Grid, Hidden } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { PlanItem } from "../PlanItem";
import { SelectItem } from "../SelectItem";
import styles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { getPlans, getPlansComparative } from "../../actions/plans";
import { useState } from "react";
import { PlanItemRow } from "../PlanItemRow";
import { threadId } from "worker_threads";
import { useParams, useLocation, useHistory } from "react-router-dom";

export const PlanList = (props: any) => {
  const classes = styles();
  const dispatch = useDispatch();
  const { plans, plansComparative } = useSelector(state => state.plans);
  const [onePlan, setOnePlan] = useState(plans);
  const [selectedOnePlan, setSelectedOnePlan] = useState<any>();
  const [secondPlan, setSecondPlan] = useState(plans);
  const [selectedSecondPlan, setSelectedSecondPlan] = useState<any>();
  const [thirdPlan, setThirdPlan] = useState(plans);
  const [selectedThirdPlan, setSelectedThirdPlan] = useState<any>();
  const [selectedLongerPlan, setSelectedLongerPlan] = useState<any>();
  const { plan1, plan2, plan3 } = useParams();
  let history = useHistory();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  let queryPlan1 = query.get("plan1");
  let queryPlan2 = query.get("plan2");
  let queryPlan3 = query.get("plan3");

  console.log(
    query.get("plan1"),
    query.get("plan2"),
    query.get("plan3"),
    "url plans"
  );
  useEffect(() => {
    dispatch(getPlans());
  }, []);

  //HIDE MENU SCROLL
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleMenuDebounce = () => {
    const currentScrollPos = window.pageYOffset;

    setVisible(prevScrollPos - currentScrollPos > 0 || currentScrollPos < 10);

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleMenuDebounce);

    return () => window.removeEventListener("scroll", handleMenuDebounce);
  }, [prevScrollPos, visible]);

  const changeHistoryParams = () => {
    let newQueryString = "?";
    if (queryPlan1) {
      newQueryString += `plan1=${queryPlan1}`;
    }
    if (queryPlan2) {
      newQueryString += `&plan2=${queryPlan2}`;
    }
    if (queryPlan3) {
      newQueryString += `&plan3=${queryPlan3}`;
    }
    history.replace(newQueryString);
  };

  useEffect(() => {
    (async () => {
      if (plans) {
        // fill combobox list
        const defaultPlans = plans.filter(plan => plan.default === true);
        await handleSelectedDefaultPlan(defaultPlans);
        setOnePlan(plans);
        setSecondPlan(plans);
        setThirdPlan(plans);
      }
    })();
  }, [plans]);

  useEffect(() => {
    if (plansComparative) {
      // fill combobox selected
      setSelectedOnePlan(plansComparative[0]);
      setSelectedSecondPlan(plansComparative[1]);
      setSelectedThirdPlan(plansComparative[2]);
      queryPlan1 = plansComparative[0].id;
      queryPlan2 = plansComparative[1].id;
      queryPlan3 = plansComparative[2].id;

      console.log("plans comparative:");
      let longerCoverages = plansComparative[0];
      plansComparative.map(plan => {
        if (plan.coverages.length > longerCoverages.coverages.length) {
          longerCoverages = plan;
        }
      });
      setSelectedLongerPlan(longerCoverages);

      changeHistoryParams();
    }
  }, [plansComparative]);

  const handleSelectedDefaultPlan = (plans: number) => {
    let query_params = {};

    if (queryPlan1 === null) {
      query_params = {
        planOneId: plans[0]?.id || "",
        planTwoId: plans[1]?.id || "",
        planThreeId: plans[2]?.id || ""
      };
    } else {
      query_params = {
        planOneId: queryPlan1,
        planTwoId: queryPlan2,
        planThreeId: queryPlan3
      };
    }

    dispatch(
      getPlansComparative(
        Object.values(query_params)
          .filter(q => q !== "" && q)
          .join()
      )
    );

    if (plansComparative) {
      setSelectedOnePlan(plansComparative[0]);
      setSelectedSecondPlan(plansComparative[1]);
      setSelectedThirdPlan(plansComparative[2]);
    }
  };

  const handleSelectedPlan = (action: string, planIdSelected: number) => {
    let query_params = {
      planOneId: selectedOnePlan?.id || "",
      planTwoId: selectedSecondPlan?.id || "",
      planThreeId: selectedThirdPlan?.id || ""
    };
    console.log("🚀 ~  handleSelectedPlan ~ query_params", query_params);

    switch (action) {
      case "selectOne":
        query_params.planOneId = planIdSelected;
        dispatch(
          getPlansComparative(
            Object.values(query_params)
              .filter(q => q !== "" && q)
              .join()
          )
        );
        console.log("🚀 ~ handleSelectedPlan 1", plansComparative[0]);
        break;
      case "selectSecond":
        query_params.planTwoId = planIdSelected;
        dispatch(
          getPlansComparative(
            Object.values(query_params)
              .filter(q => q !== "" && q)
              .join()
          )
        );
        console.log("🚀 ~ handleSelectedPlan 2", plansComparative[1]);
        break;
      case "selectThree":
        query_params.planThreeId = planIdSelected;
        dispatch(
          getPlansComparative(
            Object.values(query_params)
              .filter(q => q !== "" && q)
              .join()
          )
        );
        console.log("🚀 ~ handleSelectedPlan 3", plansComparative[2]);
        break;
    }
  };

  const listOnePlans = () => {
    return (
      onePlan?.filter(
        item =>
          selectedSecondPlan &&
          item.id !== selectedSecondPlan.id &&
          selectedThirdPlan &&
          item.id !== selectedThirdPlan.id
      ) || []
    );
  };
  const listSecondPlans = () => {
    return (
      secondPlan?.filter(
        item =>
          selectedOnePlan &&
          item.id !== selectedOnePlan.id &&
          selectedThirdPlan &&
          item.id !== selectedThirdPlan.id
      ) || []
    );
  };
  const listThirdPlans = () => {
    return (
      thirdPlan?.filter(
        item =>
          selectedOnePlan &&
          item.id !== selectedOnePlan.id &&
          selectedSecondPlan &&
          item.id !== selectedSecondPlan.id
      ) || []
    );
  };

  return onePlan ? (
    <div className={classes.marginBottomContainer}>
      <Grid
        className={visible ? classes.rootScrollList : classes.root}
        container
        justify="center"
        // style={{ top: visible ? "99px" : "20px" }}
      >
        <Grid item className={classes.columnContainer}>
          {onePlan && (
            <SelectItem
              id={1}
              listPlans={listOnePlans()}
              handleSelectedPlan={handleSelectedPlan}
              action={"selectOne"}
              auxSelectedItem={selectedOnePlan}
            />
          )}
        </Grid>
        <Grid item className={classes.columnContainer}>
          {secondPlan && (
            <SelectItem
              id={2}
              listPlans={listSecondPlans()}
              handleSelectedPlan={handleSelectedPlan}
              action={"selectSecond"}
              auxSelectedItem={selectedSecondPlan}
            />
          )}
        </Grid>
        <Hidden xsDown>
          <Grid item>
            {thirdPlan && (
              <SelectItem
                id={3}
                listPlans={listThirdPlans()}
                handleSelectedPlan={handleSelectedPlan}
                action={"selectThree"}
                auxSelectedItem={selectedThirdPlan}
              />
            )}
          </Grid>
        </Hidden>
      </Grid>
      {selectedOnePlan && (
        <PlanItemRow
          longerCoverages={selectedLongerPlan.coverages}
          selectedOnePlanError={selectedOnePlan.error}
          selectedSecondPlanError={selectedSecondPlan.error}
          selectedThirdPlanError={selectedThirdPlan.error}
          selectedOnePlanCoverages={selectedOnePlan.coverages}
          selectedSecondPlanCoverages={selectedSecondPlan.coverages}
          selectedThirdPlanCoverages={selectedThirdPlan.coverages}
        />
      )}
      <Grid className={classes.rootButtons} container justify="center">
        <Grid item className={classes.columnContainer}>
          {onePlan && (
            <div className={classes.mainContainer}>
              <Button
                className={classes.buttonPlan}
                variant="contained"
                color="primary"
                href="#"
              >
                Elegir
              </Button>
            </div>
          )}
        </Grid>
        <Grid item className={classes.columnContainer}>
          {secondPlan && (
            <div className={classes.mainContainer}>
              <Button
                className={classes.buttonPlan}
                variant="contained"
                color="primary"
                href="#"
              >
                Elegir
              </Button>
            </div>
          )}
        </Grid>
        <Hidden xsDown>
          <Grid item>
            {thirdPlan && (
              <div className={classes.mainContainer}>
                <Button
                  className={classes.buttonPlan}
                  variant="contained"
                  color="primary"
                  href="#"
                >
                  Elegir
                </Button>
              </div>
            )}
          </Grid>
        </Hidden>
      </Grid>
      <br />
      <br />
      <br />
    </div>
  ) : (
    <div>
      <div style={{ minHeight: "90vh" }}></div>
      <CircularProgress
        color="primary"
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          margin: "auto",
          zIndex: 99
        }}
      />
    </div>
  );
};
